<!-- 2FA Verification Modal -->
<div *ngIf="show" class="fixed inset-0 z-[10000] overflow-y-auto">
  <!-- Backdrop -->
  <div class="fixed inset-0 bg-black/60 backdrop-blur-sm transition-opacity"></div>
  
  <!-- Modal Container -->
  <div class="flex min-h-full items-center justify-center p-4">
    <div class="relative transform overflow-hidden rounded-2xl bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white shadow-2xl transition-all w-full max-w-md border border-slate-700/50">
      
      <!-- Header -->
      <div class="px-6 pt-6 pb-4 text-center">
        <!-- Lock Icon with Animation -->
        <div class="mx-auto w-16 h-16 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-2xl flex items-center justify-center mb-4 shadow-lg shadow-emerald-500/30 animate-pulse">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
        </div>
        
        <h3 class="text-xl font-bold bg-gradient-to-r from-white to-slate-300 bg-clip-text text-transparent">
          Two-Factor Authentication
        </h3>
        <p class="mt-2 text-sm text-slate-400">
          Enter the 6-digit code from your authenticator app
        </p>
      </div>
      
      <!-- Content -->
      <div class="px-6 pb-6">
        <!-- Code Input -->
        <div class="relative">
          <input 
            type="text"
            [ngModel]="code"
            (input)="onCodeInput($event)"
            (keypress)="onKeyPress($event)"
            [disabled]="isLoading"
            maxlength="8"
            placeholder="000000"
            autocomplete="one-time-code"
            class="w-full text-center text-3xl font-mono tracking-[0.5em] bg-slate-800/50 border-2 border-slate-600 rounded-xl py-4 px-6 text-white placeholder-slate-600 focus:outline-none focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/20 transition-all duration-200 disabled:opacity-50"
          />
          
          <!-- Code Length Indicator -->
          <div class="flex justify-center gap-2 mt-3">
            <div *ngFor="let i of [1,2,3,4,5,6]" 
                 class="w-2 h-2 rounded-full transition-all duration-200"
                 [ngClass]="code.length >= i ? 'bg-emerald-500 scale-110' : 'bg-slate-600'">
            </div>
          </div>
        </div>

        <!-- Error Message -->
        <div *ngIf="error" class="mt-4 p-3 bg-red-500/10 border border-red-500/30 rounded-lg">
          <div class="flex items-center gap-2 text-red-400 text-sm">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            <span>{{ error }}</span>
          </div>
        </div>

        <!-- Warning Message -->
        <div *ngIf="warning" class="mt-4 p-3 bg-amber-500/10 border border-amber-500/30 rounded-lg">
          <div class="flex items-center gap-2 text-amber-400 text-sm">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span>{{ warning }}</span>
          </div>
        </div>

        <!-- Backup Code Hint -->
        <p class="mt-4 text-xs text-center text-slate-500">
          Lost your device? You can use a backup code instead.
        </p>

        <!-- Actions -->
        <div class="mt-6 flex gap-3">
          <button 
            (click)="cancel()"
            [disabled]="isLoading"
            class="flex-1 px-4 py-3 text-sm font-medium text-slate-300 bg-slate-700/50 hover:bg-slate-700 rounded-xl transition-all duration-200 disabled:opacity-50">
            Cancel
          </button>
          <button 
            (click)="verify()"
            [disabled]="isLoading || code.length < 6"
            class="flex-1 px-4 py-3 text-sm font-medium text-white bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700 rounded-xl transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed shadow-lg shadow-emerald-500/30">
            <span *ngIf="!isLoading">Verify</span>
            <span *ngIf="isLoading" class="flex items-center justify-center gap-2">
              <svg class="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Verifying...
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>














